export default __webpack_public_path__ + "5d2a73855050c87cc3ce455583782a5e.svg";